import { useConfig } from 'vike-vue/useConfig'
import { useI18n } from 'vue-i18n'

export const useFormatSeoContent = (title: string, description?: string) => {
  const { locale } = useI18n()
  const setConfig = useConfig()

  setConfig({
    lang: locale.value,
    title,
    description: description?.replace(/<\/?[^>]+(>|$)/g, '').substring(0, 160),
  })
}
